import { useTranslation } from 'react-i18next'
import { List, ListItemText, ListProps, ListItemButton } from '@mui/material'
import { RuuviTag } from '../types'
import { formatMacAddress } from '../utils/string'
import { translateRuuviTagType } from '../utils/ruuviTag'

interface RuuviTagDetailsListProps extends Omit<ListProps, 'children'> {
  ruuviTag: RuuviTag
  showDevice?: boolean
}

export default function RuuviTagDetailsList({
  ruuviTag,
  showDevice = true,
  ...props
}: RuuviTagDetailsListProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('ruuvitag')

  return (
    <List {...props}>
      {ruuviTag?.asset?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.name} secondary={t('name')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.company?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.company.name} secondary={t('owner')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.project?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.project.name} secondary={t('project')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.level?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.level.name} secondary={t('level')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.lift?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.lift.name} secondary={t('lift')} />
        </ListItemButton>
      )}

      <ListItemButton>
        <ListItemText primary={formatMacAddress(ruuviTag.id)} secondary={t('macAddress')} />
      </ListItemButton>

      <ListItemButton>
        <ListItemText primary={translateRuuviTagType(ruuviTag)} secondary={t('type')} />
      </ListItemButton>

      {showDevice && ruuviTag?.deviceName && (
        <ListItemButton>
          <ListItemText
            primary={ruuviTag.device?.asset?.name ?? ruuviTag.deviceName}
            secondary={t('hostDevice')}
          />
        </ListItemButton>
      )}

      {/*{ruuviTag?.createdAt && (
        <ListItemButton>
          <ListItemText
            primary={humanizeTimestamp(ruuviTag.createdAt)}
            secondary={t('createdAt')}
          />
        </ListItemButton>
      )}*/}
    </List>
  )
}
